import { d as c, C as o, f as d } from "./component-CAYPdBLR.js";
import { T as f } from "./events-CnaEWcY_.js";
class h extends o {
  requiredRefs = ["message", "fill"];
  connectedCallback() {
    if (
      (super.connectedCallback(),
      document.addEventListener(f.cartUpdate, this.#s, { signal: this.signal }),
      window.liquidAjaxCart?.cart)
    )
      this.#e();
    else {
      const e = () => {
        (this.#e(), document.removeEventListener("liquid-ajax-cart:init", e));
      };
      document.addEventListener("liquid-ajax-cart:init", e, { signal: this.signal });
    }
  }
  #s = (e) => {
    this.#e(e.detail?.resource);
  };
  #e(e) {
    const t = parseInt(this.dataset.threshold) || 5e3;
    let s = 0;
    e?.total_price
      ? (s = e.total_price)
      : window.liquidAjaxCart?.cart?.total_price && (s = window.liquidAjaxCart.cart.total_price);
    let i = (s / t) * 100;
    if (
      (i > 100 && (i = 100),
      this.refs.fill && (this.refs.fill.style.width = `${i}%`),
      this.refs.message)
    )
      if (s >= t)
        ((this.refs.message.innerHTML = this.dataset.messageFree || "Free shipping unlocked!"),
          this.refs.fill && this.refs.fill.classList.add("csb-success"));
      else {
        const a = t - s,
          r =
            this.dataset.messageRemaining ||
            "Only <strong>AMOUNT_PLACEHOLDER</strong> left for free shipping!",
          n = this.dataset.locale || "de-DE",
          l = this.dataset.currency || "EUR";
        ((this.refs.message.innerHTML = r.replace(
          "AMOUNT_PLACEHOLDER",
          d(a, { locale: n, currency: l })
        )),
          this.refs.fill && this.refs.fill.classList.remove("csb-success"));
      }
  }
}
c("cart-progress-bar", h);
